import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'dayName',
  standalone:true
})
export class DayNamePipe implements PipeTransform {
  transform(value: number | number[]): string {
    const daysMap: { [key: number]: string } = {
      1: 'Mon',
      2: 'Tue',
      3: 'Wed',
      4: 'Thu',
      5: 'Fri',
      6: 'Sat',
      0: 'Sun',
    };

    // Check if the input is an array
    if (Array.isArray(value)) {
      return value
        .map((day) => daysMap[day] || 'Invalid Day') // Map each number to its corresponding day
        .join(', '); // Join the resulting array into a single string
    }

    // If the input is a single number
    return daysMap[value] || 'Invalid Day';
  }
}
